import { useQuery } from "react-query";
import axios from "axios";
import {useSelector } from "react-redux";
import {apiUrlSelector} from "../redux/selectors";

export const useScrapingCodes = () => {
    const apiUrl = useSelector(apiUrlSelector);
    return useQuery(["scrapping-codes", apiUrl], () =>
        axios.get(`${apiUrl}scrapping-codes`).then(res => res.data.data),
        {
            refetchOnWindowFocus: false,
            placeholderData: []
        }
    );
};

export default useScrapingCodes;